import { jsx as t, jsxs as V } from "react/jsx-runtime";
import "react";
var h = (l) => /* @__PURE__ */ V("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-588 -744)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M6.22656 11.6981C6.22656 12.3234 6.73344 12.8302 7.35863 12.8302H10.7548C10.7548 13.3512 11.1772 13.7736 11.6982 13.7736H12.8303C13.3514 13.7736 13.7737 13.3512 13.7737 12.8302V11.6981H6.22656Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M13.868 6.22648V8.868C13.868 9.28418 13.5294 9.62269 13.1133 9.62269V10.7548C14.1537 10.7548 15.0001 9.90835 15.0001 8.86796V6.22644H13.868V6.22648Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M5.75469 8.86788C5.75469 9.28405 5.41613 9.62257 5 9.62257V10.7546C6.04039 10.7546 6.8868 9.90823 6.8868 8.86784V6.22632H5.75469V8.86788Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M13.3021 6.22656H12.1699V8.86809H13.3021V6.22656Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.4721 7.73589C10.4721 7.83996 10.3874 7.9246 10.2834 7.9246C10.1793 7.9246 10.0946 7.83996 10.0946 7.73589V6.22644H8.96258V7.73589C8.96258 7.83996 8.87793 7.9246 8.77387 7.9246C8.6698 7.9246 8.58516 7.83996 8.58516 7.73589V6.22644H7.45312V7.73589C7.45312 8.46414 8.04559 9.05664 8.77387 9.05664C9.05434 9.05664 9.31449 8.96851 9.52856 8.81882C9.74266 8.96851 10.0028 9.05664 10.2832 9.05664C10.3397 9.05664 10.3952 9.05265 10.4499 9.04574C10.3696 9.37625 10.072 9.62269 9.71719 9.62269V10.7548C10.7576 10.7548 11.604 9.90835 11.604 8.86796V7.73589V6.22644H10.4719V7.73589H10.4721Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M9.15137 9.62256H7.45312V10.7547H9.15137V9.62256Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  h as default
};
